<div id="principles-container">
  <div id="content-container">
    <h1 class="card-header" *ngIf="ls.principleArticle">
      {{ls.principleHeader | translatedb | uppercase}}
    </h1>
    <div id="content" *ngIf="ls.principleArticle" [innerHTML]="ls.principleArticle | translatedb"></div>
  </div>
</div>
